/*
 *
 * Account constants
 *
 */

export const DEFAULT_ACTION = "app/Account/DEFAULT_ACTION"

export const GET_INFO_COMPANY_WATCHER = "app/Account/GET_INFO_COMPANY_WATCHER"
export const GET_INFO_COMPANY_SUCCESS = "app/Account/GET_INFO_COMPANY_SUCCESS"
export const GET_INFO_COMPANY_FAILED = "app/Account/GET_INFO_COMPANY_FAILED"

export const PUT_INFO_COMPANY_WATCHER = "app/Account/PUT_INFO_COMPANY_WATCHER"
export const PUT_INFO_COMPANY_SUCCESS = "app/Account/PUT_INFO_COMPANY_SUCCESS"
export const PUT_INFO_COMPANY_FAILED = "app/Account/PUT_INFO_COMPANY_FAILED"

export const GET_OPTIONS_WATCHER = "app/Account/GET_OPTIONS_WATCHER"
export const GET_OPTIONS_SUCCESS = "app/Account/GET_OPTIONS_SUCCESS"
export const GET_OPTIONS_FAILED = "app/Account/GET_OPTIONS_FAILED"
